import React, { useEffect, useState } from "react";
import { partners } from "../assets/features";

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((currentIndex) => (currentIndex + 1) % partners.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const handlePrev = () => {
    setCurrentIndex((currentIndex - 1 + partners.length) % partners.length);
  };

  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % partners.length);
  };

  return (
    <div className="w-full flex flex-col items-center p-8 h-[400px] relative">
      <button
        onClick={handlePrev}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 p-2 rounded-full "
      >
        <img src="/icones/left.png" alt="left" className="w-[20px]" />
      </button>
      <div className="w-full max-w-md flex flex-col items-center">
        <img
          src={partners[currentIndex].icone}
          alt={`Partner ${currentIndex + 1}`}
          className="w-full h-auto object-contain mb-4"
        />
        <p className="text-black text-center">
          {partners[currentIndex].description}
        </p>
      </div>
      <button
        onClick={handleNext}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 rounded-full"
      >
        <img src="/icones/right.png" alt="left" className="w-[20px]" />
      </button>
      <div className="absolute bottom-4 flex space-x-2">
        {partners.map((_, index) => (
          <div
            key={index}
            className={`w-3 h-3 rounded-full cursor-pointer ${
              currentIndex === index ? "bg-black" : "bg-gray-500"
            }`}
            onClick={() => setCurrentIndex(index)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
